import Normalize from './Normalize'
import NormalizeBaseFonts from './NormalizeBaseFonts'

export default Normalize
export { NormalizeBaseFonts }
